// Shared by every controller on the page that needs to ask "does this element's content actually
// overflow/wrap it" (short_label_controller, header_actions_controller): reading a layout
// property like scrollWidth or scrollHeight right after writing a style/attribute change forces
// the browser to synchronously flush and recompute layout right then, the classic "layout
// thrashing" trap. A page like organizations/show.html.erb can have a dozen-plus of these buttons
// connecting at once; each one measuring independently forced its own separate reflow back to
// back, measurably slowing page load down, not imagined.
//
// The fix is the standard one: batch every pending measurement into a single animation frame,
// write nothing more until they've all been read, then read every one of them together (forcing
// exactly one reflow for the whole batch, not one per element), and only run every caller's own
// write-back afterward. Read-then-write, never interleaved, across the whole batch. measureFn is
// whatever geometry check a given caller needs (scrollWidth vs clientWidth for "would this
// label wrap", scrollHeight vs its own line-height for "did this title actually wrap already"),
// so this one queue serves callers asking genuinely different questions.
const pending = []
let scheduled = false

export function measure(element, measureFn, callback) {
  pending.push({ element, measureFn, callback })

  if (!scheduled) {
    scheduled = true
    requestAnimationFrame(flush)
  }
}

function flush() {
  const batch = pending.splice(0, pending.length)
  scheduled = false

  // Read phase: every element's geometry, back to back, forcing one reflow for the batch.
  const results = batch.map(({ element, measureFn }) => measureFn(element))

  // Write phase: nothing above touched the DOM, so nothing forces a second reflow here.
  batch.forEach(({ callback }, i) => callback(results[i]))
}
